import { debounce } from 'lodash';
import domReady from '../helpers/dom-ready';

class WC {
  static init(...parameters) {
    return new WC(...parameters);
  }

  constructor() {
    this.setupProductDetailsList();
  }

  setupProductDetailsList() {
    const list = document.querySelector('.product-details-expandable-list');
    if (list) {
      const listItems = list.querySelectorAll('.product-details-expandable-list-item');
      if (listItems.length > 0) {
        // First list item should initially be expanded
        const firstListItem = listItems[0];
        const firstListItemContent = firstListItem.querySelector('.list-item-content');
        this.onClickExpandButton(firstListItem, firstListItemContent);

        [...listItems].forEach((listItem) => {
          const listItemLabel = listItem.querySelector('.list-item-label');
          const listItemContent = listItem.querySelector('.list-item-content');
          listItemLabel.addEventListener('click', () => this.onClickExpandButton(listItem, listItemContent));
        });
      }

      window.addEventListener('resize', debounce(() => {
        if (listItems.length > 0) {
          [...listItems].forEach((listItem) => {
            const listItemContent = listItem.querySelector('.list-item-content');
            const innerBlocksWrapper = listItem.querySelector('.inner-blocks');

            if (listItem.classList.contains('-expanded')) {
              listItemContent.style.height = `${innerBlocksWrapper.scrollHeight}px`;
            }
          });
        }
      }, 50));
    }
  }

  onClickExpandButton(listItem, listItemContent) {
    const listItemContentStyle = listItemContent.style;

    if (listItem.classList.contains('-expanded')) {
      listItem.classList.remove('-expanded');
      listItemContentStyle.height = '0px';
      listItem.setAttribute('aria-expanded', false);
    } else {
      listItem.classList.add('-expanded');
      listItemContentStyle.height = `${listItemContent.scrollHeight}px`;
      listItem.setAttribute('aria-expanded', true);
    }
  }
}

domReady(() => {
  WC.init();
});
